export const CHROME_WEB_STORE_URL =
  "https://chromewebstore.google.com/detail/gidnchdemajnccbjkenopapjcopghnmn?utm_source=item-share-cb";

// TODO: Replace 'your-extension-id' with the actual extension ID when published
// The extension ID is the long string that appears in the Chrome Web Store URL
// Example: https://chrome.google.com/webstore/detail/fendly-content-filtering/abcdefghijklmnopqrstuvwxyz123456

export const EXTENSION_CONFIG = {
  name: "Fendly Content Filtering",
  description: "Advanced content filtering and productivity protection",
  version: "1.0.0",
  webStoreUrl: CHROME_WEB_STORE_URL,
  features: [
    "Instant content blocking",
    "Smart keyword filtering",
    "Scheduled productivity sessions",
    "Real-time protection",
  ],
};
